import React from "react"
import { useTranslation } from "react-i18next"

const EvaluationSection1 = ({ section, onAnswerChange, answers }) => {
  const { t } = useTranslation()

  const handleChange = (qIndex, questionId, value) => {
    onAnswerChange(section.main_question.id, qIndex, questionId, value)
  }

  return (
    <div className="mb-4 border p-3 rounded">
      <h5 className="mb-3">{section.title}</h5>
      <div>
        {section.sub_questions.map((q, index) => (
          <div key={q.id} className="mb-2">
            <label className="d-block mb-1">
              <strong>{q.question_number}.</strong> {q.question}
            </label>
            <div className="d-flex align-items-center gap-3">
              <label className="me-3 d-flex align-items-center gap-2">
                <input
                  type="radio"
                  name={`question_${q.id}`}
                  value="yes"
                  onChange={() => handleChange(index, q.id, true)}
                />
                {t("Yes")}
              </label>
              <label className="d-flex align-items-center gap-2">
                <input
                  type="radio"
                  name={`question_${q.id}`}
                  value="no"
                  onChange={() => handleChange(index, q.id, false)}
                />
                {t("No")}
              </label>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default EvaluationSection1
